// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "3617d5f80-dirty",
    "hash": "3617d5f80",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3617d5f80-dirty",
    "semverString": null,
    "version": "0.0.0",
    "buildDate": "11/3/2026",
    "buildTime": "Tue, 03 Nov 2026 21:33:15 GMT"
};
/* eslint:enable */
